"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = _interopRequireDefault(require("../Input"));
var _styledSystem = require("styled-system");
var _Button = _interopRequireDefault(require("../Button"));
var _constant = require("../../styles/constant");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
const inputFit = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      minHeight: (0, _constant.get)('space.32'),
      fontSize: (0, _constant.get)('fontSizes.s')
    },
    medium: {
      minHeight: (0, _constant.get)('space.40'),
      fontSize: (0, _constant.get)('fontSizes.m')
    },
    large: {
      minHeight: (0, _constant.get)('space.48'),
      fontSize: (0, _constant.get)('fontSizes.l')
    }
  }
});
const buttonFit = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      padding: props => "".concat((0, _constant.get)('space.5')(props), " ").concat((0, _constant.get)('space.0')(props))
    },
    medium: {
      padding: props => "".concat((0, _constant.get)('space.9')(props), " ").concat((0, _constant.get)('space.0')(props))
    },
    large: {
      padding: props => "".concat((0, _constant.get)('space.13')(props), " ").concat((0, _constant.get)('space.0')(props))
    }
  }
});
const iconFit = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      fontSize: (0, _constant.get)('fontSizes.s')
    },
    medium: {
      fontSize: (0, _constant.get)('fontSizes.m')
    },
    large: {
      fontSize: (0, _constant.get)('fontSizes.l')
    }
  }
});
const variants = {
  inputFit,
  buttonFit,
  iconFit
};
const Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  flex-direction: column;\n  align-items: center;\n"])));
const Label = _styledComponents["default"].label(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: 0 0 ", " 0;\n"])), (0, _constant.get)('space.4'));
const InputElement = (0, _styledComponents["default"])(_Input["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  border-radius: 0;\n  text-align: center;\n  &:disabled {\n    cursor: 'not-allowed',\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  input {\n    border-radius: 0;\n  }\n"])), variants.inputFit, (0, _constant.get)('colors.functional.grey.100'), (0, _constant.get)('colors.functional.grey.300'), (0, _constant.get)('colors.functional.grey.400'));
const ButtonElement = (0, _styledComponents["default"])(_Button["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  &.minusButton {\n    border-right: none;\n    border-radius: ", " 0 0 ", ";\n  }\n  &.plusButton {\n    border-left: none;\n    border-radius: 0 ", " ", " 0;\n  }\n  justify-content: center;\n  &:disabled {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  > button {\n    ", "\n  }\n  i {\n    ", "\n  }\n"])), (0, _constant.get)('space.3'), (0, _constant.get)('space.3'), (0, _constant.get)('space.3'), (0, _constant.get)('space.3'), (0, _constant.get)('colors.functional.grey.50'), (0, _constant.get)('colors.functional.grey.400'), (0, _constant.get)('colors.functional.grey.900'), variants.buttonFit, variants.iconFit);
const Components = exports.Components = {
  ButtonElement,
  InputElement,
  Label,
  Wrapper
};